import { createSelector } from 'reselect';

import { getElementId, getImageProp, getImageThumbnail } from '../../../../common/elements/utils/elementPropertyUtils';
import { hasProgressiveImageLoaded } from '../../../components/images/progressiveImages/progressiveImagesSingleton';
import { getIsFeatureEnabledForCurrentUser } from '../../feature/elementFeatureSelector';
import { getImageSource } from '../imageHelper';
import { IMAGE_SIZES } from '../../../../common/images/imageConstants';
import { ExperimentId } from '../../../../common/experiments/experimentsConstants';
import { ImMNElement } from '../../../../common/elements/elementModelTypes';
import { ReduxState } from '../../../types/reduxTypes';

const useSecureMediaUrl = true;

type ImageModalSelectorProps = {
    element: ImMNElement;
};

const renderSecureImagesThroughCFSelector = getIsFeatureEnabledForCurrentUser(
    ExperimentId.renderSecureImagesThroughCF,
    true,
);

/**
 * Uses the best already-loaded progressive image as the modal placeholder before the full image resolves.
 */
export const lowerQualityImageUrlSelector = createSelector(
    (_: ReduxState, { element }: ImageModalSelectorProps) => element,
    renderSecureImagesThroughCFSelector,
    (element, renderSecureImagesThroughCF) => {
        const imageDetails = getImageProp(element);
        const elementId = getElementId(element);
        const imageUrls = [IMAGE_SIZES.LARGE, IMAGE_SIZES.REGULAR].map((imageSize) =>
            getImageSource({
                imageDetails,
                imageSize: imageSize.name,
                elementId,
                useSecureMediaUrl,
                renderSecureImagesThroughCF,
            }),
        );

        return imageUrls.find((url) => hasProgressiveImageLoaded(url)) || getImageThumbnail(element);
    },
);
